import { gql } from '@ts-gql/tag';

import { useQuery } from '@reckon-web/gql-api-client';

type UseGetUserPermissionsQueryProps = {
  bookId?: string;
  skip?: boolean;
};

const UseGetUserPermissionsQuery = gql`
  query UseGetUserPermissionsQuery($bookId: ID!) {
    authenticatedUser {
      id
      allPermissions(bookId: $bookId)
    }
  }
` as import('../../../__generated__/ts-gql/UseGetUserPermissionsQuery').type;

export function useGetUserPermissionsQuery({
  bookId,
  skip,
}: UseGetUserPermissionsQueryProps) {
  const { data, loading, error } = useQuery(UseGetUserPermissionsQuery, {
    variables: {
      bookId: bookId || '',
    },
    skip,
  });

  const userId = data?.authenticatedUser?.id;
  const permissions = data?.authenticatedUser?.allPermissions || [];

  return {
    userId,
    permissions,
    hasPermission: (key: string) => permissions.includes(key),
    error: error?.message,
    isLoading: !!loading,
  };
}
